import RegisterFrom from "./RegisterFrom";

export function CadastroFrom() {
  return (
    <div className="flex justify-center items-center p-16">
      <RegisterFrom />
    </div>
  );
}
